import React from "react";
import { Select } from "antd";

export default function PageFilter({ pageOptions, selectedPage, onChange }) {
  const options = [
    { label: "Todas as páginas", value: "all" },
    ...pageOptions.map((page) => ({
      label: page,
      value: page,
    })),
  ];

  return (
    <div style={{ marginBottom: 24, maxWidth: 360 }}>
      <Select
        style={{ width: "100%" }}
        value={selectedPage}
        onChange={onChange}
        options={options}
        placeholder="Filtrar por página"
      />
    </div>
  );
}